import { mapState, mapGetters } from 'vuex';

const partnerSettings = {
  computed: {
    ...mapState({
      showWarningOnExit: (state) => state.partnerSettings.showWarningOnExit,
      warningTab: (state) => state.partnerSettings.warningTab,
      showAction: (state) => state.partnerSettings.showAction,
      contacts: (state) => state.partnerSettings.contacts,
      actionView: (state) => state.partnerSettings.actionView,
      selectedPlan: (state) => state.partnerSettings.selectedPlan,
      servicesOffering: (state) => state.partnerSettings.servicesOffering,
      partner: (state) => state.partnerDetail.partner,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'adminRole',
    ]),
  },
  methods: {
    changePartnerSettingsValue(field, value) {
      this.$store.dispatch('changePartnerSettingsValue', {
        field,
        value,
      });
    },
    toggleModal(show, view, item) {
      const changes = [{
        field: 'showAction',
        value: show,
      },
      {
        field: 'actionView',
        value: view,
      }];
      if (!show) {
        this.changePartnerSettingsValue('showAction', false);
      } else if (view === 'warning-save') {
        changes.push({
          field: 'warningTab',
          value: item,
        });
      } else if (view === 'connect') {
        changes.push({
          field: 'serviceInfo',
          value: item,
        });
      } else if (view === 'service-changes-warning') {
        changes.push({
          field: 'servicesOffering',
          value: item,
        })
      }
      this.$store.dispatch('changePartnerSettingsValues', changes);
    },
  },
};

export default partnerSettings;
